import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    Snackbar, Alert, Tooltip, IconButton
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@material-ui/core";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import DownloadIcon from '@mui/icons-material/Download';
import LoadingButton from '@mui/lab/LoadingButton';
import VisibilityIcon from "@mui/icons-material/Visibility";
import Chip from '@mui/material/Chip';


const Quter = [
    { id: "Q1", value: `Quarter 1 Apr-Jun` },
    { id: "Q2", value: `Quarter 2 Jul-Sep` },
    { id: "Q3", value: `Quarter 3 Oct-Dec` },
    { id: "Q4", value: `Quarter 4 Jan-Mar` },
];

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "10px 26px 10px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            borderRadius: 4,
            borderColor: "rgba(0,123,255)",
        },
    },
}));

export default function Filing26Q() {
    let history = useHistory();
    const [yearFromArr, setFromYearArr] = useState([]);
    const [year, setYear] = useState("");
    const [quarter, setQuarter] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false)
    // Snackbar state
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });

    useEffect(() => {
        getApiForReport();
        setFromYearValues()
    }, []);

    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 8; i <= current_year + 2; i++) {
            let startYear = i;
            let endYear = i + 1;
            let endYearShort = endYear.toString().slice(-2);
            yearArr.push({ id: i, year: `${startYear}-${endYearShort}` });
        }
        setFromYearArr(yearArr);
    };


    // Handle Snackbar close
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };


    // Reset Form
    const handleOpenAndCloseModel = () => {
        setQuarter(null);
        setYear(null);
    };


     const handleBackNavigation = () => {
  history.push('/Filing');
};


    // Submit Button
    const onSubmitHandler = () => {
        setSubmitBtnLoading(true)
        axios
            .post(`/is_eligible_to_file_26q`, {
                business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
                financial_year: year,
                quarter: quarter
            })
            .then((res) => {
                if (res?.data?.status) {
                    localStorage.setItem("financial_year_26Q", `${year}`);
                    localStorage.setItem("quarter_26Q", quarter);
                    history.push({
                        pathname: `/26QFormFiling`
                    })
                } else {
                    setSnackbar({
                        open: true,
                        message: res?.data?.message,
                        severity: 'warning'
                    });
                }
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setSubmitBtnLoading(false)
            });
    };


    const getApiForReport = () => {
        axios
            .get(`/get_filing_logs_26q/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                setTableData(res?.data?.records || []);
            })
            .catch((err) => {
                console.log(err);
                setTableData([]);
            });
    };


    const onTextFileExport = (txtFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.txt`;
        downloadBase64File('text/plain', txtFileBinary, filename);
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    // downloadPDF = (base64Data, fileName) => {
    //     const linkSource = base64Data;
    //     const downloadLink = document.createElement("a");
    //     downloadLink.href = linkSource;
    //     downloadLink.download = fileName;
    //     downloadLink.click();
    // };

    const onFUVFileExport = (fvuFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.zip`;
        downloadBase64File('application/zip', fvuFileBinary, filename);

    }

    const onReceiptFileExport = (receiptFileBinary, financial_year, quarter) => {
        const filename = `${financial_year}_${quarter}.pdf`;
        console.log(receiptFileBinary);
        downloadBase64File('application/pdf', receiptFileBinary, filename);
    }


    const onExportFileExport = (errorFileBinary) => {
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `Form26q Error Filing Report.xlsx`;
        downloadBase64File(contentType, errorFileBinary, filename);
    }

    const downloadBaseFile = (contentType, base64Data, fileName) => {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
        window.URL.revokeObjectURL(url); // Clean up
        downloadLink.remove();
    };

    return (
        <React.Fragment>
                    <div style={{
                      padding: "15px 20px",
                      backgroundColor: "#f5f5f5"
                    }}>
                       <Tooltip title="Back" arrow>
                                              <IconButton
                                               onClick={handleBackNavigation}
                                                sx={{
                                                  borderRadius: '50%',
                                                  padding: '6px',
                                                  color: '#263238',
                                                  fontSize: '20px',
                                                  backgroundColor: '#ffffff',
                                                  height: '36px',
                                                  width: '36px',
                                                  '&:hover': {
                                                    backgroundColor: '#455a64',
                                                    color: '#ffffff',
                                                  },
                                                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                                  transition: 'background-color 0.3s ease',
                                                }}
                                              >
                                                <ArrowBackIcon sx={{ fontSize: '20px' }} />
                                              </IconButton>
                                            </Tooltip>
                    </div>

            <BoxWrapper boxTitle="26Q Filing">
                <ValidatorForm
                    useRef="form"
                    onSubmit={onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={4} lg={4}>
                            <label>
                                Financial year<sup style={{ color: "red" }}>*</sup>:
                            </label>
                            <FormControl sx={{ minWidth: "100%" }}>
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    value={year}
                                    onChange={(e) => {
                                        setYear(e.target.value);
                                    }}
                                    input={<BootstrapInput />}
                                    required
                                >
                                    {yearFromArr.map((v) => {
                                        return <MenuItem value={v.year}>{v.year}</MenuItem>;
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={4} lg={4}>
                            <label>
                                Quarter :
                            </label>
                            <FormControl sx={{ minWidth: "100%" }}>
                                <Select
                                    labelId="demo-customized-select-label"
                                    id="demo-customized-select"
                                    value={quarter}
                                    onChange={(e) => {
                                        setQuarter(e.target.value);
                                    }}
                                    input={<BootstrapInput />}
                                    required
                                >
                                    {Quter.map((v) => {
                                        return <MenuItem value={v.id}>{v.value}</MenuItem>;
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} lg={4} style={{ display: 'flex', flexDirection: 'row' }}>
                            <LoadingButton
                                loading={submitBtnLoading}
                                variant="contained"
                                // color="primary"
                                type="submit"
                                // onClick={onSubmitHandler}
                                sx={{ mt: '28px', width: '100px', py: '1px', mr: 2, backgroundColor: 'var(--app-bar-bg)', color: 'white' }}
                            >
                                Submit
                            </LoadingButton>
                            <button
                                className="button-outlined-secondary"
                                style={{ marginTop: "28px", width: "100px", padding: "1px" }}
                                type="button"
                                onClick={handleOpenAndCloseModel}
                            >
                                Cancel
                            </button>
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </BoxWrapper>

            <BoxWrapper
                boxTitle="26Q Filing Report"
                searchInputPlaceholder="Search..."
                enableAddButton={true}
                addButtonLabel="Refresh"
                addButtonHandlerFn={getApiForReport}
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Financial Year</th>
                                <th>TAN</th>
                                <th>Quarter</th>
                                <th>TXT File</th>
                                <th>Fuv File</th>
                                <th>Receipt File</th>
                                <th>Action</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.map((value) => (
                                <tr key={value.id}>
                                    <td>{value.financial_year}</td>
                                    <td>{value.tan}</td>
                                    <td>{value.quarter}</td>
                                    <td>
                                        {value?.txt_url ? (
                                            <IconButton color="primary" size="small">
                                                <DownloadIcon
                                                    onClick={() => onTextFileExport(value.txt_file_binary, value.financial_year, value.quarter)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </IconButton>
                                        ) : null}
                                    </td>
                                    <td>
                                        {value?.fvu_zip_url ? (
                                            // <a href={value.fvu_zip_url} rel="noopener noreferrer" download>
                                            <IconButton color="primary" size="small">
                                                <DownloadIcon
                                                    onClick={() => onFUVFileExport(value.fvu_zip_file_binary, value.financial_year, value.quarter)}
                                                    style={{ cursor: 'pointer' }} />
                                            </IconButton>
                                            // </a>
                                        ) : (
                                            null
                                        )}
                                    </td>
                                    <td>
                                        {value?.receipt_file_url ? (
                                            // <a href={value.receipt_file_url} rel="noopener noreferrer" download>
                                            <IconButton color="primary" size="small">
                                                <DownloadIcon
                                                    onClick={() => onReceiptFileExport(value.receipt_file_binary, value.financial_year, value.quarter)}
                                                    style={{ cursor: 'pointer' }} />
                                            </IconButton>
                                            // </a>
                                        ) : (
                                            null
                                        )}
                                    </td>
                                    <td>
                                        {value?.error_file_url ? (
                                            // <a href={value.error_file_url} rel="noopener noreferrer" download>
                                            <IconButton color="primary" size="small">
                                                <DownloadIcon
                                                    onClick={() => onExportFileExport(value.error_file_binary, value.financial_year, value.quarter)}
                                                    style={{ cursor: 'pointer' }} />
                                            </IconButton>
                                            // </a>
                                        ) : null}
                                        {value?.status.toLowerCase() === 'failed' && (
                                            <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() =>
                                                    setSnackbar({
                                                        open: true,
                                                        message: value?.error_message,
                                                        severity: 'error',
                                                    })
                                                }
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        )}
                                    </td>
                                    <td>
                                        <Chip label={value?.status.toUpperCase()}
                                            color={
                                                value?.status.toLowerCase() === 'succeeded'
                                                    ? 'success' // Green for succeeded
                                                    : value?.status.toLowerCase() === 'failed'
                                                        ? 'error' // Red for failed
                                                        : value?.status.toLowerCase() === 'inprogress'
                                                            ? 'warning' // Orange for inprogress
                                                            : 'default' // Fallback color
                                            } variant="outlined" />
                                        {/* {value?.status.toUpperCase()} */}

                                    </td>

                                </tr>
                            ))}
                            {tableData.length <= 0 && (
                                <tr>
                                    <td style={{ color: "red", textAlign: "center" }} colSpan={6}>
                                        No Data Found!!
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );


}